import type {
  CampaignProduct,
  CampaignProductVariant,
} from '@bvengineering/cas-member-gateway-service-client';

export const variantInStock = (v: CampaignProductVariant): boolean =>
  (v.remainingSampleCount ?? 0) > 0;

export const findReservedUserProduct = (
  userProducts: CampaignProduct[] | null | undefined
): CampaignProduct | null =>
  userProducts?.find((p) => p.state?.toLowerCase() === 'reserved' && !p.claimedDate) ?? null;
